import script from "./musique.vue?vue&type=script&setup=true&lang=js"
export * from "./musique.vue?vue&type=script&setup=true&lang=js"

import "./musique.vue?vue&type=style&index=0&id=3b0ad73c&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0ad73c"]])

export default __exports__